<template>
  <div class="empty_page">
    <!-- 首页如果没有食物分类显示这个空页面 -->
    <div class="back" @click="goBack()">
      <img src="./../../../assets/images/canEat/arrow_left.png" alt="">
    </div>
    <section class="section">
      <div class="pic">
        <img src="./../../../assets/images/canEat/empty_pic.png" alt="">
      </div>
      <p>还没上架相关内容~</p>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'Empty',
    data() {
      return {}
    },
    methods: {
      goBack() {
        this.$router.push({
          path: '/home'
        })
      }
    }
  }
</script>

<style lang="less" scoped>
.empty_page {
  width: 100%;
  height: 100%;
  padding: 0 12px;
  box-sizing: border-box;
  background: #F7F7F7;
  .back {
    width: 100%;
    height: 40px;
    line-height: 40px;
    >img {
      width: 11px;
      height: 20px;
      color: #1A1A1A;
      vertical-align: middle;
    }
  }
  .section {
    width: 100%;
    margin-top: 143px;
    .pic {
      width: 100%;
      text-align: center;
      >img {
        width: 109px;
        height: 91px;
      }
    }
    p {
      margin-top: 27px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      text-align: center;
    }
  }
}
</style>